import {useQuery} from '@tanstack/react-query'
import {useAuthUser} from 'react-auth-kit'

import {sampleSchema} from '../domain'
import {useSample} from '../hook'

export function useGetSample() {
  const auth = useAuthUser()
  const {sampleSet} = useSample()

  const userID = auth()?.id

  return useQuery(
    ['dashboard'],
    async () => {
      const response = await fetch('https://jsonplaceholder.typicode.com/users/' + userID)
      const data = await response.json()

      const safeParse = sampleSchema.safeParse(data)

      if (!safeParse.success) {
        throw new Error(safeParse.error.message)
      }

      const parse = sampleSchema.parse(data)

      sampleSet({
        id: parse.id,
        name: parse.name,
      })

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: () => {},
      onError: (error) => {
        console.log(error)
      },
    }
  )
}
